import { Component, OnInit, ViewChild } from '@angular/core';
import { HelperService, AppSettings, AuthenticationService, Agents } from '../../../services/_services';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
declare var document, $;

@Component({
  selector: 'app-completed-orders',
  templateUrl: './completed-orders.component.html',
  styleUrls: ['./completed-orders.component.css']
})
export class CompletedOrdersComponent implements OnInit {

    public activeUser         : any;
    public browserSub         : any;

    public writerRatings : any = [
                                    { name: 'With Feedback',    value: 1 },
                                    { name: 'Without Feedback', value: 0 }
                                 ];

    public loading            : any = false;
    public lead_Index         : any = null;
    public paginatePage       : any;
    public leads              : any = [];
    public comments           : any = [];
    public agentComments      : any = [];
    public qaComments         : any = [];
    public agentsSub          : any;
    public agents             : any;
    public proofreaders       : any;
    public writers            : any;
    public qa                 : any;
    public loader             : any;


    @ViewChild(DataTableDirective)
    public dtElement    : DataTableDirective;
    public dtOptions    : DataTables.Settings = {};
    public dtTrigger    : any = new Subject();

    public searchParams          : any = { order_id: '', proof_reader: null, writer: null, rating: null, client_feedback: null, date_from: '', date_to: ''};
    public fullRangeDate         : any;
    public selectedDesposition   : any;

    constructor(
      private authenticationService : AuthenticationService,
      private helperService         : HelperService,
      private agentsService         : Agents,
    ) {

      this.browserSub = this.authenticationService.isBrowser.subscribe(isBrowser => {
        if (isBrowser) {
          // Get Agents
          this.agentsSub = this.agentsService.agentsS$.subscribe(agents => {
            if (agents) {
              this.agents       = agents.agents;
              this.proofreaders = agents.proofreaders;
              this.writers      = agents.writers;
              this.qa           = agents.qa;
            }
          });

          // Get Active User
          this.activeUser = this.authenticationService.get_currentUserValue();

          // Set Defualt date range
          if(this.activeUser.Portal_Writer)
            this.setDefualtDateRange();

          // Init DataTable
          this.dtOptions = {
            paging: true,
            info: true,
            // ordering: false,
            pagingType: 'full_numbers',
            pageLength: 10,
            serverSide: true,
            processing: true,
            searching: false,
            'language': AppSettings.dataTableLang,
            "columnDefs": [
              { "orderable": false,     "targets": 0  },
              { "orderable": false,     "targets": 1  },
              { "orderable": false,     "targets": 2  },
              { "orderable": false,     "targets": 3  },
              { "orderable": false,     "targets": 4  },
              { "orderable": false,     "targets": 5  },
              { "orderable": false,     "targets": 6  },
              { "orderable": false,     "targets": 7  },
              { "orderable": false,     "targets": 8  },
              { "orderable": false,     "targets": 9  },
              { "orderable": false,     "targets": 10 }
            ],
            "order": [[ 0, "desc" ]],
            ajax: (dataTablesParameters: any, callback) => {
              // Show Loader
              this.loading = true;
              // console.log("dataTablesParameters", dataTablesParameters);

              let url = AppSettings.API_ENDPOINT + 'writers/completed-orders';;

              let dtParams = {
                              order_id          : this.searchParams.order_id,
                              proof_reader      : this.searchParams.proof_reader,
                              writer            : this.searchParams.writer,
                              rating            : this.searchParams.rating,
                              client_feedback   : this.searchParams.client_feedback,
                              date_from         : this.searchParams.date_from ? this.helperService.caonvertDateToString(this.searchParams.date_from) : '',
                              date_to           : this.searchParams.date_to   ? this.helperService.caonvertDateToString(this.searchParams.date_to, false)   : '',
                              start             : dataTablesParameters.start,
                              length            : dataTablesParameters.length,
                              order             : dataTablesParameters.order,
                              columns           : dataTablesParameters.columns
                            };

              // For Record Serial Numbers
              this.paginatePage = dataTablesParameters.start;

              // Empty Data
              this.leads = [];

              this.helperService.httpPostRequestsDecryp(url, dtParams)
                .then( resp => {
                    this.leads        = JSON.parse(resp);
                    // console.log("this.leads: ", this.leads);

                    // Set Default page len
                    this.dtOptions.pageLength = this.dtElement['dt'].page.len();

                    // Hide Loader
                    this.loading = false;

                    callback({
                      recordsTotal: this.leads.total,
                      recordsFiltered: this.leads.total,
                      // recordsFiltered: resp['recordsFiltered'],
                      // recordsFiltered: 1000,
                      data: []
                    });

                    // // $(".paginate_button .current").css("color", "white");
                    // // console.log('$(".paginate_button .current"): ',$(".paginate_button .current"))
                    $('div.dataTables_length select').addClass('dt-form-control');
                    $('div.dataTables_filter input').addClass('dt-form-control');
                })
                .catch(error => {
                    // Set loader false
                    this.loading = false;

                    // // Rerender DT in case of failure
                    // this.rerender();

                    console.log("error: ",error);
                });
            },
            columns: [
              // { data: 'multiDelete' },
              { data: 'id' },
              { data: 'oid' },
              { data: 'due_date' },
              { data: 'sub_date' },
              { data: 'pages' },
              { data: 'status' },
              { data: 'attachments' },
              { data: 'status2' },
              { data: 'quality' },
              { data: 'qa_rating' },
              { data: 'feed' },
            ],
            // Use this attribute to enable the responsive extension
            responsive: false
          }
        }
      });
    }

    ngOnInit() {
    }

    ngAfterViewInit(){
      this.dtTrigger.next();
    }

    ngOnDestroy(): void {
      // Do not forget to unsubscribe the event
      this.dtTrigger.unsubscribe();

      if (typeof this.agentsSub != 'undefined') {
        //prevent memory leak when component destroyed
        this.agentsSub.unsubscribe();
        this.browserSub.unsubscribe();
      }
    }

    rerender(): void {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {

        // Destroy the table first
        dtInstance.destroy();

        // Call the dtTrigger to rerender again
        this.dtTrigger.next();
      });
    }

    splitFromTo(){
      if(this.fullRangeDate) {
        this.searchParams.date_from = this.fullRangeDate[0];
        this.searchParams.date_to =   this.fullRangeDate[1];
      }

      this.rerender();
    }

    getCustomerFeedbackForWriter(lead, index) {
      // Show loader
      this.leads.data[index].loadingFeed = true;

      let url = AppSettings.API_ENDPOINT + "shared/get-client-feedback-by-order-writer";
      let data = { writer_id: lead.writer_id, order_id: lead.oid };

      this.helperService.httpPostRequests(url,data).then(resp => {
          if(typeof resp != "undefined") {
            this.comments  = resp.data;

            if (this.comments.length == 0) {
              Swal.fire('No Feedback Available', "" , 'info');
            }
            else {
              if (typeof $ != "undefined") {
                // Show Popup
                $("#wrFeedBack_modal").modal("show");
              }
            }
          }

          // Hide loader
          this.leads.data[index].loadingFeed = false;
      }).catch(err => {
          // Hide loader
          this.leads.data[index].loadingFeed = false;
      });
    }

    downloadWR_Attach(lead, index) {
      // Show Zip loader
      this.leads.data[index].creatingZip = true;

      let url  = AppSettings.API_ENDPOINT + "shared/create-wco-zip";
      let data = { id: this.leads.data[index].wco };

      this.helperService.httpPostRequests(url,data).then(resp => {
          if(typeof resp != "undefined" && resp.status == 'OK') {
              window.open(resp.zip, '_blank');
          } else {
              Swal.fire('', resp.message , 'error');
          }

          // Hide Zip loader
          this.leads.data[index].creatingZip = false;
      }).catch(err => {
          // Hide Zip loader
          this.leads.data[index].creatingZip = false;
      });
    }

    showFeedback(lead, index, type){
      // Show loader
      this.leads.data[index].loadingQAFeed = true;
      this.lead_Index                      = index;

      this.loader = lead.id;

      let url = AppSettings.API_ENDPOINT + "shared/get-comments";
      let data = { o: lead.oid, type: type };
      this.helperService.httpPostRequests(url,data).then(resp => {
          if(typeof resp != "undefined") {
            this.comments      = resp.data;

            if (this.comments.length == 0) {
              Swal.fire('No comments', "Comments are not added yet." , 'info');
            }
            else {
              if (typeof $ != "undefined") {
                for (let i = 0; i < this.comments.length; i++) {
                  if(typeof this.comments[i].notes.split('<strong>')[1] != 'undefined')
                    this.comments[i]['qaRating'] = parseFloat(this.comments[i].notes.split('<strong>')[1].split('</strong>')[0]);
                }

                // Show Popup
                $("#qaFeedBack_modal").modal("show");
              }
            }
          }

          // Hide loader
          this.leads.data[index].loadingQAFeed = false;
      }).catch(err => {
          // Hide loader
          this.leads.data[index].loadingQAFeed = false;
      });
    }

    agentSearch(id, array) {
      for (var i = 0; i < array.length; i++) {
        if (array[i].id === id) {
          return array[i].name;
        }
      }
    }

    parseFloat(value){
      return parseFloat(value);
    }

    setDefualtDateRange() {
      let startDate = new Date();
          startDate = new Date(startDate.getFullYear(), startDate.getMonth(), 1);

      this.fullRangeDate = [startDate, new Date()];

      if(this.fullRangeDate) {
        this.searchParams.date_from = this.fullRangeDate[0];
        this.searchParams.date_to =   this.fullRangeDate[1];
      }
    }

    clearFilters(){
      this.fullRangeDate = '';
      this.searchParams = { order_id: '', proof_reader: null, writer: null, rating: null, client_feedback: null, date_from: '', date_to: ''};

      // Set Defualt date range
      if(this.activeUser.Portal_Writer)
        this.setDefualtDateRange();

      this.rerender();
    }

}
